import React from "react";
import {Badge} from "reactstrap";
import QUOTE_STATUS_COLORS from "../../domain/quote.status.colors.js";
import {formatStatusStringForDisplay} from "../../helper/formatters.js";
import QuoteReservesBadge from "./QuoteReservesBadget";
import {faBoxesPacking} from "@fortawesome/free-solid-svg-icons";

const QuoteStatusBadge = ({quote}) => {
    const status = quote.status.current;
    // Get color from dictionary, default to 'dark' if not found
    const color = QUOTE_STATUS_COLORS[status] || "dark";

    return (
        <>
            <Badge color={color} pill className={"me-1"}>
                {formatStatusStringForDisplay(status)} {/* Format status to be more readable */}
            </Badge>
            <QuoteReservesBadge quote={quote} text="" icon={faBoxesPacking} />
        </>
    );
};

export default QuoteStatusBadge;